import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, until } from '@helpers/media';
import { contentStyles, h2 } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  @media ${until(Device.TabletSmall)} {
    ${SectionWrapperStyles.SiteWide} {
      --sitePadding: var(--gutterWidth);
    }
  }
`;
const Inner = styled.div `
  padding: ${fluid(20, 30)} ${fluid(26, 40)} 30px ${fluid(16, 30)};
  box-shadow: 0 0 6px ${rgba(brand.black, 0.16)};
  border-left: 20px solid var(--themeColor);
`;
const Heading = styled.h2 `
  ${h2};
`;
const Content = styled.div `
  ${contentStyles};

  p,
  ol li,
  ul li {
    font-size: ${fluid(18, 24)};
    line-height: ${fluid(24, 30)};
  }
`;
export const HighlightedInformationStyles = {
    Container,
    Content,
    Heading,
    Inner,
};
